import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { CartProvider } from "./contexts/CartContext";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { ScrollToTop } from "./components/ScrollToTop";
import { ScrollToTopOnNavigate } from "./components/ScrollToTopOnNavigate";
import Home from "./pages/Home";
import Recordings from "./pages/Recordings";
import CategoryPage from "./pages/CategoryPage";
import CustomRecording from "./pages/CustomRecording";
import RecordingDetail from "./pages/RecordingDetail";
import Cart from "./pages/Cart";
import Success from "./pages/Success";
import About from "./pages/About";
import IsThisForMe from "./pages/IsThisForMe";
import Admin from "./pages/Admin";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";

function App() {
    useEffect(() => {
        // Remove edge-injected prerender block once React has hydrated
        const prerender = document.getElementById("seo-prerender");
        if (prerender) prerender.remove();
        document.querySelectorAll("script[data-seo-edge]").forEach((s) => s.remove());
    }, []);

    return (
        <CartProvider>
            <div className="App min-h-screen bg-nature-50">
                <BrowserRouter>
                    <ScrollToTopOnNavigate />
                    <Header />
                    <main className="pt-16">
                        <Routes>
                            <Route path="/" element={<Home />} />
                            <Route path="/recordings" element={<Recordings />} />
                            <Route path="/custom-recording" element={<CustomRecording />} />
                            <Route path="/recordings/:categorySlug" element={<CategoryPage />} />
                            <Route path="/recording/:slug" element={<RecordingDetail />} />
                            <Route path="/cart" element={<Cart />} />
                            <Route path="/success" element={<Success />} />
                            <Route path="/about" element={<About />} />
                            <Route path="/is-this-for-me" element={<IsThisForMe />} />
                            <Route path="/blog" element={<Blog />} />
                            <Route path="/blog/:slug" element={<BlogPost />} />
                            <Route path="/admin" element={<Admin />} />
                        </Routes>
                    </main>
                    <Footer />
                    <ScrollToTop />
                </BrowserRouter>
                <Toaster position="bottom-right" />
            </div>
        </CartProvider>
    );
}

export default App;
